<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import type { EmeterMainMetric } from 'src/helpers/emeter_main_metric';
	import { capFirstChar, convert } from 'src/helpers/utilities';
	import { get_gen_2_component_channel_structure } from 'src/helpers/interface_helpers';
	import { Alert, ParameterCardV2 } from '@Shelly/shelly-design-system';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';

	export let device: Device;
	export let status: Record<string, any>;
	export let metric: EmeterMainMetric = 'power';

	$: em1 = status?.[`em1:${device.channel}`];
	$: ctNotCalibrated = status?.[get_gen_2_component_channel_structure(device)]?.errors?.includes(
		'ct_type_not_set',
	);

	$: otherValue = metric === 'power' ? em1?.current : em1?.act_power;
	$: otherUnit = metric === 'power' ? 'A' : 'W';
	$: otherDescription =
		metric === 'power'
			? $format('em_current', { default: 'current' })
			: $format('em_power', { default: 'power' });
</script>

{#if !ctNotCalibrated}
	{#if typeof em1?.voltage !== 'undefined'}
		<ParameterCardV2
			title={convert(em1.voltage, 'V')}
			description={$format('em_voltage', { default: 'voltage' })}
			size="s"
			class="mb-s"
		/>
	{/if}

	{#if typeof otherValue !== 'undefined'}
		<ParameterCardV2
			title={convert(otherValue, otherUnit)}
			description={otherDescription}
			size="s"
			class="mb-s"
		/>
	{/if}

	{#if typeof em1?.aprt_power !== 'undefined'}
		<ParameterCardV2
			title={convert(em1.aprt_power, 'VA')}
			description={capFirstChar(
				$format('em_aparent_power', {
					default: 'apparent power',
				}),
			)}
			size="s"
			class="mb-s"
		/>
	{/if}

	{#if typeof em1?.pf !== 'undefined'}
		<ParameterCardV2
			title={em1.pf === 0 ? 'N/A' : em1.pf}
			description={$format('em_power_factor', {
				default: 'power factor',
			})}
			size="s"
			class="mb-s"
		/>
	{/if}

	{#if typeof em1?.freq !== 'undefined'}
		<ParameterCardV2
			title={`${em1.freq} Hz`}
			description={$format('em_freq', { default: 'frequency' })}
			size="s"
			class="mb-s"
		/>
	{/if}
{:else}
	<Alert
		type="warning"
		class="mb-s"
		heading={$format('em_ct_not_set_error_heading', {
			default: 'CT error type not set',
		})}
		message={$format('em_ct_not_set_error_description', {
			default: 'This channel need to have selected CT type in order to show power metering.',
		})}
		isHeadingBold
		cta={{
			title: $format('settings', { default: 'Settings' }),
		}}
		on:cta_click={() => navigateToSetting(device.id, 'settings', 'change_ct_type')}
	/>
{/if}
